import React, { useState } from "react";
import { ProcedureDayOneQuestions, procedureDayOneData, procedureDayTwoData, procedureDentalList, aboutFaqs, procedurePriceData, procedureBottomData } from "../../secondUtils/constants";
import { FaCheck, FaRegCircle } from "react-icons/fa";
import aboutHeaderImg from "../../secondAssets/Images/aboutHeaderImg.png"
import dayTwoHeaderImg from "../../secondAssets/Images/procedureDayTwoHeaderImg.jpg"

const ProcedureComponent = (props) => {
    const { selectedLanguage, language, procedureDentistry_banner, name } = props;
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [activeIndex, setActiveIndex] = useState(0)
    const toggleActiveIndex = (index) => {
        setActiveIndex(index);
    };
    return (
        <div className="main">
            <div className="procedure-component-main">
                <div className="procedure-banner-div"
                    data-aos="fade-up"
                    data-aos-easing="ease-out-bounce"
                    data-aos-delay="300"
                    data-aos-duration="2000">
                    <img src={procedureDentistry_banner} alt="" />
                </div>
                <div className="procedure-dental-filling-section">
                    <h1
                        data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">{name}</h1>
                    <div className="procedure-dental-filling-text-div">
                        <div
                            data-aos="fade-right"
                            data-aos-easing="ease-out-bounce"
                            data-aos-delay="300"
                            data-aos-duration="2000">
                            <p>{selectedLanguage?.txt_they_are_about_to_receive}</p>
                            <p>{selectedLanguage?.txt_for_more_information}</p>
                        </div>
                        <ul data-aos="fade-left"
                            data-aos-easing="ease-out-bounce"
                            data-aos-delay="300"
                            data-aos-duration="2000">
                            {
                                procedureDentalList?.map((v, i) => {
                                    return (
                                        <li><FaCheck className="list-check-icon" />
                                            {isELSelect ? v?.point : (isAlSelect ? v?.alPoint : v?.glPoint)}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className="day-one-section">
                    <div className="day-one-section-heading-div"
                        data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={aboutHeaderImg} alt="" />
                        <div>
                            <div></div>
                            <h2>{selectedLanguage?.txt_day_1}</h2>
                            <div></div>
                        </div>
                    </div>
                    <div className="LocationSection-container day-one-cards-div">
                        {
                            procedureDayOneData?.map((v, i) => {
                                return (
                                    <div data-aos="fade-up"
                                        data-aos-easing="ease-out-bounce"
                                        data-aos-delay="300"
                                        data-aos-duration="2000">
                                        <img src={v?.img} alt="" />
                                        <div className="location-btn-div">
                                            <button className="location-btn day-one-btn">
                                                +
                                            </button>
                                        </div>
                                        <h2>
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                        </h2>
                                        <p>
                                            {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                        </p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="day-one-questions-div">
                        {ProcedureDayOneQuestions?.map((v, i) => {
                            return (
                                <div data-aos="fade-up"
                                    data-aos-easing="ease-out-bounce"
                                    data-aos-delay="300"
                                    data-aos-duration="2000">
                                    <p><span>
                                        {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                    </span>
                                        {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="day-one-section">
                    <div className="day-one-section-heading-div day-two-section-heading-div" data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <img src={dayTwoHeaderImg} alt="" />
                        <div>
                            <div></div>
                            <h2>{selectedLanguage?.txt_day_2}</h2>
                            <div></div>
                        </div>
                    </div>
                    <div className="procedure-dayTwo-img-section">
                        {
                            procedureDayTwoData?.map((v, i) => {
                                return (
                                    <div data-aos="fade-up"
                                        data-aos-easing="ease-out-bounce"
                                        data-aos-delay="300"
                                        data-aos-duration="2000">
                                        <div>
                                            <div className="procedure-dayTwo-img-overLap-div">
                                                <div>
                                                    <p>{selectedLanguage?.txt_suspendisse_urn_nibh}</p>
                                                    <button>{selectedLanguage?.txt_consult_now}</button>
                                                </div>
                                            </div>
                                            <img src={v?.img} alt="" />
                                        </div>
                                        <h2>
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                        </h2>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="procedure-questions-div">
                        {aboutFaqs.map((v, i) => (
                            <div key={i} data-aos="fade-up"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <div className="about-faqs-question-div" onClick={() => toggleActiveIndex(i)}>
                                    <button><FaRegCircle /></button>
                                    <h2 className={activeIndex === i ? "about-faqs-question active-question" : "about-faqs-question procedure-faqs-question"}>
                                        {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                    </h2>
                                </div>
                                {activeIndex === i ? <p className="about-answer procedure-answer">
                                    {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                                </p> : null}
                            </div>
                        ))}
                    </div>
                    <div className="procedure-subscription-main"
                        data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        {
                            procedurePriceData?.map((v, i) => {
                                return (
                                    <div>
                                        <div>
                                            <div className="procedure-subscription-div">
                                                <div className={i === 1 ? "inner-div top-div procedure-center-price-card" : "inner-div top-div"}>
                                                    <div className="procedure-month-div">
                                                        <h1>{v?.months}</h1>
                                                        <h2>
                                                            {selectedLanguage?.txt_month} <br />{selectedLanguage?.txt_plan}
                                                        </h2>
                                                    </div>
                                                </div>
                                                <div className={i === 1 ? "inner-div bottom-div procedure-center-price-bottom-card" : "inner-div bottom-div"}>
                                                    <div className="procedure-price-div">
                                                        <h2>
                                                            <sup>$</sup>{v?.price}.00
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="procedure-price-card-text">
                                                {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                            </p>
                                            <div className="procedure-price-border-bottom">
                                            </div>
                                        </div>
                                        <button className={i === 1 ? "procedure-price-card-btn procedure-price-card-center-btn" : "procedure-price-card-btn"}>{selectedLanguage?.txt_book_now}</button>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="procedure-bottom-section">
                        {
                            procedureBottomData?.map((v, i) => {
                                return (
                                    <div data-aos="fade-up"
                                        data-aos-easing="ease-out-bounce"
                                        data-aos-delay="300"
                                        data-aos-duration="2000">
                                        <div className="procedure-bottom-sec-btn-div">
                                            <button>{v?.icon}</button>
                                        </div>
                                        <div className="procedure-bottom-sec-text-div">
                                            <h2>
                                                {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                            </h2>
                                            <p>
                                                {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProcedureComponent